// extracted by mini-css-extract-plugin
export default {"cta":"xH-z","disabled":"yH-z"};